// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"4907f158","453":"221c6fb1","457":"e10497ea","551":"7a2fbebf"}[chunkId] + ".chunk.js";
};